import {api} from 'services/api';
import {ResponseData} from 'types/response-data';
import {HomePageSettings} from 'types/home-page';

export const getHomePageSettings = api.injectEndpoints({
  endpoints: builder => ({
    getHomePageSettings: builder.query<Response, void>({
      query: () => ({
        method: 'GET',
        url: `settings/web-home-page`,
      }),
      // @ts-expect-error
      providesTags: result =>
        result ? [{type: 'HomePageSettings'}] : [],
    }),
  }),
});

type Response = ResponseData<HomePageSettings>;

export const {useGetHomePageSettingsQuery} = getHomePageSettings;

export const homePageSettingsEndpoint =
  getHomePageSettings.endpoints.getHomePageSettings;
